import { create } from "zustand";
import { IGif } from "@/common/api/services/types";

interface ISfwState {
  sfwGifs: IGif[];
  sfwImages: string[];
  setSfwGifs: (gifs: IGif[]) => void;
  setSfwImages: (urls: string[]) => void;
}

export const useSfwStore = create<ISfwState>(
  (set) => ({
    sfwGifs: [],
    sfwImages: [],
    setSfwGifs: (gifs: IGif[]) => set(() => ({ sfwGifs: gifs })),
    setSfwImages: (urls: string[]) => set(() => ({ sfwImages: urls })),
  }),
);
